<template>
    <portal to="root">
        <div
            style="z-index: 50;"
            class="fixed overflow-x-hidden h-full w-screen bg-white dark:bg-black-900 top-0 left-0 p-4 md:p-12"
        >
            <header class="w-full flex items-center justify-between relative">
                <button
                    @click="$emit('close')"
                    class="flex items-center text-gray-600 dark:text-gray-400 focus:outline-none focus:shadow-outline rounded-sm px-4 py-2 rounded-lg bg-gray-200 dark:bg-gray-900 hover:bg-gray-300 dark-hover:bg-gray-700 transition duration-150"
                >
                    <icon-svg
                        class="w-4 mr-4 text-gray-500"
                        icon="thin-arrow-left"
                    />

                    Back to {{ backTo }}
                </button>

                <logo
                    variant="logo-small"
                    class="hidden text-secondary sm:inline w-12 absolute mx-auto top-0 left-0 right-0"
                />
            </header>

            <div class="w-full max-w-screen-lg mx-auto mt-16 md:mt-28">
                <slot />
            </div>
        </div>
    </portal>
</template>

<script>
export default {
    name: "FullScreenOverlay",
    props: {
        backTo: {
            type: String,
            default: "Dashboard",
        },
    },
};
</script>
